import { render, staticRenderFns } from "./ListOrderedActivities.vue?vue&type=template&id=298447f8"
import script from "./ListOrderedActivities.vue?vue&type=script&lang=ts"
export * from "./ListOrderedActivities.vue?vue&type=script&lang=ts"
import style0 from "./ListOrderedActivities.vue?vue&type=style&index=0&id=298447f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports